import { periodsRetrieveAllLisaPeriods } from '@sunwisesoftware/client-zap-js';

import authenticate from './authenticate';

export default ({ credentialId, limit = 12, rpuId }) =>
    authenticate(() =>
        periodsRetrieveAllLisaPeriods({
            query: { credential_id: credentialId, limit: limit, rpu_id: rpuId },
        }),
    );
